import { ElInfiniteScroll } from '@hd-front-end/components/infinite-scroll'
import { ElLoading } from '@hd-front-end/components/loading'
import { ElMessage } from '@hd-front-end/components/message'
import { ElMessageBox } from '@hd-front-end/components/message-box'
import { ElNotification } from '@hd-front-end/components/notification'
import { ElPopoverDirective } from '@hd-front-end/components/popover'

import type { Plugin } from 'vue'

export default [
  ElInfiniteScroll,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElPopoverDirective,
] as Plugin[]
